import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type InvoiceCollectionDetailFragment = { __typename?: 'InvoiceCollection', id: string, name: string, scope: Types.InvoiceCollectionScope, invoice_email?: string | null, purchasing_order_email?: string | null, invoice_headline?: string | null, legal_name?: string | null, vat_number?: string | null, invoice_email_subject_prefix?: string | null, invoice_collection_debitor_account_number: number, disable_automatic_partner_invoice_sending?: boolean | null, collapse_invoice_items?: boolean | null, needs_invoice_collection_breakdown?: boolean | null, regular_payment_target_days?: number | null, sepa_2_percent_discount?: boolean | null, dunning_reminder_block_type?: Types.DunningReminderBlockType | null, dunning_reminder_block_reason?: string | null, dunning_reminder_block_until?: string | null, is_dunning_reminder_stopped?: boolean | null, inkassokennzeichen?: boolean | null, invoice_routing_id?: string | null, order_number?: string | null, seller_id?: string | null, external_id?: string | null, needs_purchasing_order_number?: boolean | null, billomat_client_id?: string | null, type?: Types.StoreType | null, partner_account_ids?: Array<string | null> | null, store_ids?: Array<string | null> | null, excluded_store_ids?: Array<string | null> | null, partner_accounts: Array<{ __typename?: 'InvoiceCollectionPartnerAccount', id: string, name?: string | null, company_name?: string | null, parent_account_id?: string | null, partner_account_path?: string | null, store_count: number }>, stores: Array<{ __typename?: 'Store', id: string, name?: string | null, external_vytal_id?: string | null, currency?: Types.Currency | null, currency_symbol?: string | null, dunning_reminder_block_type?: Types.DunningReminderBlockType | null, dunning_reminder_block_reason?: string | null, dunning_reminder_block_until?: string | null } | null>, excluded_stores: Array<{ __typename?: 'Store', id: string, name?: string | null } | null>, invoice_address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, street_extra?: string | null, zip?: string | null, city?: string | null, country?: string | null } | null, change_history?: Array<{ __typename?: 'InvoiceCollectionChangeHistory', old_values?: string | null, new_values?: string | null, changed_at?: string | null, changed_by?: string | null, changed_by_raw?: string | null } | null> | null };

export const InvoiceCollectionDetailFragmentDoc = gql`
    fragment InvoiceCollectionDetail on InvoiceCollection {
  id
  name
  scope
  invoice_email
  purchasing_order_email
  invoice_headline
  legal_name
  vat_number
  invoice_email_subject_prefix
  invoice_collection_debitor_account_number
  disable_automatic_partner_invoice_sending
  collapse_invoice_items
  needs_invoice_collection_breakdown
  regular_payment_target_days
  sepa_2_percent_discount
  dunning_reminder_block_type
  dunning_reminder_block_reason
  dunning_reminder_block_until
  is_dunning_reminder_stopped
  inkassokennzeichen
  invoice_routing_id
  order_number
  seller_id
  external_id
  needs_purchasing_order_number
  billomat_client_id
  type
  partner_account_ids
  store_ids
  excluded_store_ids
  partner_accounts {
    id
    name
    company_name
    parent_account_id
    partner_account_path
    store_count
  }
  stores {
    id
    name
    external_vytal_id
    currency
    currency_symbol
    dunning_reminder_block_type
    dunning_reminder_block_reason
    dunning_reminder_block_until
  }
  excluded_stores {
    id
    name
  }
  invoice_address {
    streetname
    streetno
    street_extra
    zip
    city
    country
  }
  change_history {
    old_values
    new_values
    changed_at
    changed_by
    changed_by_raw
  }
}
    `;